import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { configs } from '../../constants/configs/configs';
// Components
import TransferPopupModal from '../../components/entity/modals/TransferPopupModal';

// ActionCreators

// Constants
import { entityModalTypes } from '../../constants/entity/modals/entityModalTypes';
import { acknowledgeTransferStatus } from '../../actions/common/actionCreators';

const EntityModalContainer = props => {
    const { endpoints } = configs;
    const {
        actions,   
        entityActions,     
        data,        
        modal,
        modal: {
            modalType
        },
        environment: {
            user: {
                role
            }            
        },        
        ...restProps
    } = props;

    const acknowledgeTransferStatusFn = ()=>{
        entityActions.acknowledgeTransferStatus(endpoints.ACK_TRNFR_STATUS);
    };

    //redirecting outside react pages
    const redirectWhenTransferFn = () => {
        window.location.href = endpoints.ENTITY_ASSISTERS_LIST; 
    }; 


    const onHide = () => {
        switch (modalType) {
            case entityModalTypes.TRANSFER_SUCCESS_MODAL:
                return redirectWhenTransferFn();
            case entityModalTypes.TRANSFER_VALIDATION_ERROR_MODAL:
                return  acknowledgeTransferStatusFn();
        }
    };

    const extendedProps = {
        ...restProps,
        actions,
        data,
        modal
    };
    const hideCloseIcon = modalType === entityModalTypes.TRANSFER_IN_PROGRESS_MODAL;

    const getModal = () => {
        switch (modalType) {
            case entityModalTypes.TRANSFER_FAILURE_MODAL:
            case entityModalTypes.TRANSFER_INCOMPLETE_MODAL:
            case entityModalTypes.TRANSFER_IN_PROGRESS_MODAL:
            case entityModalTypes.TRANSFER_PARTIAL_SUCCESS_MODAL:
            case entityModalTypes.TRANSFER_SUCCESS_MODAL:
                return <TransferPopupModal { ...{ ...extendedProps, actions: { ...actions, onHide } } } userRole={role} hideCloseIcon = {hideCloseIcon}/>;       
            case entityModalTypes.TRANSFER_ERROR_MODAL:
                return <TransferPopupModal { ...{ ...extendedProps,actions: { ...actions, onHide } } } userRole={role} hideCloseIcon = {hideCloseIcon}/>;       
            case entityModalTypes.TRANSFER_VALIDATION_ERROR_MODAL:  
                return <TransferPopupModal { ...extendedProps } userRole={role} hideCloseIcon = {hideCloseIcon} />;
        }
    };

    return getModal();
};

const mapStateToProps = state => ({
    spinner: state.common.spinner,
    environment: state.common.environment,
    entity: state.entity
});

const mapDispatchToProps = dispatch => ({
    entityActions: bindActionCreators({
        acknowledgeTransferStatus
    }, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(EntityModalContainer);
